<div class="success-wrapper">
    <div class="success-card">
        <div class="icon-container" *ngIf="isSuccess">
            <svg class="check-icon" viewBox="0 0 24 24">
                <path fill="none" stroke="white" stroke-width="3" d="M4 12l6 6L20 6" />
            </svg>
        </div>
        <div class="icon-container" *ngIf="!isSuccess">
            <svg class="error-icon" viewBox="0 0 24 24">
                <path fill="none" stroke="white" stroke-width="3" d="M12 4.5v10M12 18v1.5" />
            </svg>
        </div>
        <h2>{{ title }}</h2>
        <p *ngIf="isSuccess">{{ message }} <span id="countdown">3</span> seconds...</p>
        <p *ngIf="!isSuccess">{{ message }}</p>
        <ng-container *ngIf="!isExpired else emailRequest"></ng-container>
        <button *ngIf="!isSuccess && !isExpired" (click)="returnToLoginPage()">Return to login</button>
        <button *ngIf="isSuccess" (click)="redirectToLogin()">Login Now</button>
    </div>
</div>

<ng-template #emailRequest>
    <div class="email-request field">
        <rh-ui-field idInput="email">
            <input
                class="input"
                type="text"
                name="email"
                id="email"
                placeholder="Enter your email"
                [(ngModel)]="email" />
        </rh-ui-field>
    </div>
    <button style="padding-right: 16px;" type="button" (click)="validateAndRequestEmail()">Request new email</button>
</ng-template>
